import { useState, useEffect } from 'react';

// Must match the mobile media query in components/MobileFAB.css so the
// chat input hint appears exactly when the skate FAB is visible.
const MOBILE_QUERY =
  '(max-width: 767px), ((max-height: 500px) and (orientation: landscape) and (pointer: coarse))';

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(MOBILE_QUERY).matches);

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY);
    const handleChange = (e) => setIsMobile(e.matches);
    mql.addEventListener('change', handleChange);
    return () => mql.removeEventListener('change', handleChange);
  }, []);

  return isMobile;
}

export default useIsMobile;
